import Fuse from 'fuse.js'

export default (search = '', tags) =>
  new Fuse(tags.toArray(), {
    threshold: 0.25,
    keys: [
      {
        name: 'name',
        weight: 0.75,
      },
      {
        name: 'alias',
        weight: 0.25,
      },
    ],
    id: 'name',
  }).search(search)



// WEBPACK FOOTER //
// ./src/utils/suggest.js